import { RouteRecordRaw } from 'vue-router'

import Login from '@/pages/Login.vue'
import Home from '@/pages/Home.vue'
import ForgotPassword from '@/pages/ForgotPassword.vue'
import FirstChangePassword from '@/pages/FirstChangePassword.vue'
import ResetPassword from '@/pages/ResetPassword.vue'
import Account from '@/pages/Account.vue'
import AccountChangeName from '@/pages/AccountChangeName.vue'
import AccountChangeNickName from '@/pages/AccountChangeNickName.vue'
import AccountChangeEmail from '@/pages/AccountChangeEmail.vue'
import AccountChangePrefectures from '@/pages/AccountChangePrefectures.vue'
import AccountChangeTradingviewName from '@/pages/AccountChangeTradingviewName.vue'
import AccountChangePassword from '@/pages/AccountChangePassword.vue'
import AccountConfirmEmail from '@/pages/AccountConfirmEmail.vue'
import Contact from '@/pages/Contact.vue'
import VideoList from '@/pages/VideoList.vue'
import VideoCategoryList from '@/pages/VideoCategoryList.vue'
import VideoBookmarkList from '@/pages/VideoBookmarkList.vue'
import VideoWatchHistoryList from '@/pages/VideoWatchHistoryList.vue'
import VideoDetails from '@/pages/VideoDetails.vue'
import SeminarList from '@/pages/SeminarList.vue'
import SeminarDetails from '@/pages/SeminarDetails.vue'
import PageDetails from '@/pages/PageDetails.vue'
import NoticeList from '@/pages/NoticeList.vue'
import NoticeDetails from '@/pages/NoticeDetails.vue'
import TermsLabo from '@/pages/TermsLabo.vue'
import TermsShindo from '@/pages/TermsShindo.vue'
import NotFound from '@/pages/NotFound.vue'

import SurveyTool from '@/pages/tools/SurveyTool.vue'
import SurveyToolRanking from '@/pages/tools/SurveyToolRanking.vue'
import Daijyunkan from '@/pages/tools/Daijyunkan.vue'
import BrandScreener from '@/pages/tools/BrandScreener.vue'
import PracticeTool from '@/pages/tools/PracticeTool.vue'
import PracticeToolResult from '@/pages/tools/PracticeToolResult.vue'
import FundsManagement from '@/pages/tools/FundsManagement.vue'

import { authMiddleware, guestMiddleware } from './navigation-guards'

export const HOME_PATH = '/home' //使う箇所が多いので一旦homeだけ変数化

export const routes: Array<RouteRecordRaw> = [
  { path: '/', redirect: HOME_PATH },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: guestMiddleware
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    beforeEnter: guestMiddleware
  },
  {
    path: '/first/change-password/:token',
    name: 'FirstChangePassword',
    component: FirstChangePassword,
    beforeEnter: guestMiddleware
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    beforeEnter: guestMiddleware
  },
  {
    path: '/terms-labo',
    name: 'Terms-Labo',
    component: TermsLabo
  },
  {
    path: '/terms-shindo',
    name: 'Terms-Shindo',
    component: TermsShindo
  },
  {
    path: HOME_PATH,
    name: 'Home',
    component: Home,
    beforeEnter: authMiddleware
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/change-name',
    name: 'AccountChangeName',
    component: AccountChangeName,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/change-nick-name',
    name: 'AccountChangeNickName',
    component: AccountChangeNickName,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/change-email',
    name: 'AccountChangeEmail',
    component: AccountChangeEmail,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/change-prefectures',
    name: 'AccountChangePrefectures',
    component: AccountChangePrefectures,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/change-tradingview-name',
    name: 'AccountChangeTradingviewName',
    component: AccountChangeTradingviewName,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/change-password',
    name: 'AccountChangePassword',
    component: AccountChangePassword,
    beforeEnter: authMiddleware
  },
  {
    path: '/account/confirm-email/:confirmation_token',
    name: 'AccountConfirmEmail',
    component: AccountConfirmEmail,
    beforeEnter: authMiddleware
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    beforeEnter: authMiddleware
  },
  {
    path: '/video',
    name: 'VideoList',
    component: VideoList,
    beforeEnter: authMiddleware
  },
  {
    path: '/video/category',
    name: 'VideoCategoryList',
    component: VideoCategoryList,
    beforeEnter: authMiddleware
  },
  {
    path: '/video/bookmark',
    name: 'VideoBookmarkList',
    component: VideoBookmarkList,
    beforeEnter: authMiddleware
  },
  {
    path: '/video/watch-history',
    name: 'VideoWatchHistoryList',
    component: VideoWatchHistoryList,
    beforeEnter: authMiddleware
  },
  {
    path: '/video/:video_id',
    name: 'VideoDetails',
    component: VideoDetails,
    beforeEnter: authMiddleware
  },
  {
    path: '/seminar',
    name: 'SeminarList',
    component: SeminarList,
    beforeEnter: authMiddleware
  },
  {
    path: '/seminar/:seminar_id',
    name: 'SeminarDetails',
    component: SeminarDetails,
    beforeEnter: authMiddleware
  },
  {
    path: '/page/:page_id',
    name: 'PageDetails',
    component: PageDetails,
    beforeEnter: authMiddleware
  },
  {
    path: '/notice',
    name: 'NoticeList',
    component: NoticeList,
    beforeEnter: authMiddleware
  },
  {
    path: '/notice/:notice_id',
    name: 'NoticeDetails',
    component: NoticeDetails,
    beforeEnter: authMiddleware
  },

  // *--- 以下 旧会員サイトVue2より移行 ---*
  {
    path: '/tools/survey-tool/ranking/:survey_tool_id',
    component: SurveyToolRanking,
    beforeEnter: authMiddleware
  },
  {
    path: '/tools/survey-tool/:survey_tool_id',
    component: SurveyTool,
    beforeEnter: authMiddleware
  },
  {
    path: '/tools/daijyunkan/:key',
    component: Daijyunkan,
    beforeEnter: authMiddleware
  },
  {
    path: '/tools/brand-screener',
    component: BrandScreener,
    beforeEnter: authMiddleware
  },
  {
    path: '/tools/practice-tool/result',
    component: PracticeToolResult,
    beforeEnter: authMiddleware
  },
  {
    path: '/tools/practice-tool/:id',
    component: PracticeTool,
    beforeEnter: authMiddleware
  },
  {
    path: '/tools/funds-management',
    component: FundsManagement,
    beforeEnter: authMiddleware
  },

  // *--- NotFound ---*
  {
    path: '/:pathMatch(.*)*',
    component: NotFound
  },
]
